"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Notice = _interopRequireDefault(require("./Notice"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const translate = {
  es: {
    TITLE: 'Sin coincidencias',
    DESCRIPTION: 'Intenta con otro término de búsqueda.'
  }
};
function NoticeEmptySearch() {
  return /*#__PURE__*/_react.default.createElement(_Notice.default, {
    name: "search_off",
    title: translate['es'].TITLE,
    description: translate['es'].DESCRIPTION
  });
}
var _default = exports.default = NoticeEmptySearch;